export const FAILED_DELETE_USER = 'FAILED_DELETE_USER'
export const FAILED_GET_USER = 'FAILED_GET_USER'
export const FAILED_GET_USERS = 'FAILED_GET_USERS'
export const FAILED_LOGIN_USER = 'FAILED_LOGIN_USER'
export const FAILED_LOGOUT_USER = 'FAILED_LOGOUT_USER'
export const FAILED_PERSIST_USER = 'FAILED_PERSIST_USER'
export const FAILED_USER_AUTH_STATUS = 'FAILED_USER_AUTH_STATUS'
export const RECEIVE_DELETE_USER = 'RECEIVE_DELETE_USER'
export const RECEIVE_GET_USER = 'RECEIVE_GET_USER'
export const RECEIVE_GET_USERS = 'RECEIVE_GET_USERS'
export const RECEIVE_LOGIN_USER = 'RECEIVE_LOGIN_USER'
export const RECEIVE_LOGOUT_USER = 'RECEIVE_LOGOUT_USER'
export const RECEIVE_PERSIST_USER = 'RECEIVE_PERSIST_USER'
export const RECEIVE_USER_AUTH_STATUS = 'RECEIVE_USER_AUTH_STATUS'
export const REQUEST_DELETE_USER = 'REQUEST_DELETE_USER'
export const REQUEST_GET_USER = 'REQUEST_GET_USER'
export const REQUEST_GET_USERS = 'REQUEST_GET_USERS'
export const REQUEST_LOGIN_USER = 'REQUEST_LOGIN_USER'
export const REQUEST_LOGOUT_USER = 'REQUEST_LOGOUT_USER'
export const REQUEST_PERSIST_USER = 'REQUEST_PERSIST_USER'
export const REQUEST_USER_AUTH_STATUS = 'REQUEST_USER_AUTH_STATUS'
